// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".statistics-table-header[data-v-5831431e]{font-size:18px;font-weight:600}.intel-info[data-v-5831431e]{font-size:smaller;color:#d3d3d3}@media(min-width:992px){.creative-title[data-v-5831431e]{padding-left:30px}}@media(min-width:1200px){.creative-title[data-v-5831431e]{padding-left:20px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
